<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="资质信誉"
      third-bread="案例与新闻查看"
      first-url="/user/sign"
      second-url="/user/news"
      title-name="案例与新闻查看"
    ></user-detail-title>
    <user-detail-base style="height: 81vh;">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="大类">
          <span>{{LookData.type}}</span>
        </el-form-item>
        <el-form-item label="小类">
          <span>{{LookData.smallType}}</span>
        </el-form-item>
        <el-form-item label="标题">
          <span>{{LookData.title}}</span>
        </el-form-item>
        <el-form-item label="主图">
          <el-image class="item-image" :src="'http://'+LookData.mainPhotoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="主图描述">
          <p>{{LookData.mainDescription}}</p>
        </el-form-item>
        <el-form-item label="描述">
          <div v-html="LookData.description"></div>
        </el-form-item>


      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "NewsLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:{
          'type':'',
          'smallType': '',
          'title': '',
          'mainPhotoUrl':'',
          'mainDescription': '',
          'description': '',
        }
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/case/getById/'+id).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>